import { useEffect, useState } from 'react';
import axiosInstance from 'services/axiosInstance';
import useLoading from "../../../../hooks/useLoading";
import LayoutDetails from '../../../LayoutModal/LayoutDetails';
import Loading from '../../../Loading';
import * as S from './style';
//Interface
import { IService } from 'Interfaces/IService';
//Utils
import { CurrencyFormat } from 'utils/CurrencyFormat';
import FormatarData from 'utils/FormatData';

interface IDetails {
    isOpenModal: boolean;
    setModalClose: () => void;
    selectedUrlId: number | null;
}

export default function Details({ isOpenModal, setModalClose, selectedUrlId }: IDetails) {
    const [data, setData] = useState<IService | null>(null);
    const { isLoading, startLoading, stopLoading } = useLoading();

    const fetchData = async () => {
        startLoading();
        try {
            const response = await axiosInstance.get(`service/${selectedUrlId}`);
            setData(response.data);

        } catch (error) {
            console.log('Error: ', error);
        } finally {
            stopLoading();
        }
    }

    useEffect(() => {
        if (isOpenModal && selectedUrlId !== null) {
            fetchData();
        }
    }, [isOpenModal, selectedUrlId])

    if (isOpenModal) {
        return (

            <LayoutDetails
                title='Detalhes do Serviço'
                subTitle='Veja todos os detalhes disponíveis sobre o Serviço.'
                setModalClose={setModalClose}>
                {isLoading || !data ? ( // Se estiver carregando ou os dados forem nulos, mostra o loading
                    <Loading />
                ) : (
                    <S.Content>
                        <S.Header>
                            <S.ContentInfor>
                                <S.Infor>
                                    <p>Nome:</p>
                                    <span>{data.name || '-'}</span>
                                </S.Infor>
                                <S.Infor>
                                    <p>Preço:</p>
                                    <span>{CurrencyFormat(parseFloat(data.price.toString())) || '-'}</span>
                                </S.Infor>
                            </S.ContentInfor>
                        </S.Header>

                        <S.Body>
                            <S.FeaturedSection>
                                <S.InforBody>
                                    <p>Descrição</p>
                                    <S.Description>{data.description || '-'}</S.Description>
                                </S.InforBody>
                            </S.FeaturedSection>

                            <S.InforBody>
                                <S.InforSmall>Cadastrado em: {FormatarData(data.created_at || "-")}</S.InforSmall>
                                <S.InforSmall>Ultima atualização em: {FormatarData(data.updated_at) || "-"}</S.InforSmall>
                            </S.InforBody>
                        </S.Body>
                    </S.Content>
                )}
            </LayoutDetails>
        )
    } return null
}